import { formatInTimeZone } from 'date-fns-tz';
import { DATE_FORMATS } from 'Utils/formats';
import { createDiagonalPattern } from 'Shared/Chart/fromPhoebe/linePattern';
import {
  temperatureWidgetData,
  windWidgetData,
  rainWidgetData,
} from '../globalWidgetsData';
import { ChartWidgetData, WidgetData } from '../types';

/**
 * Относительня влажность
 */
const humidityAMKWidgetData: WidgetData = [
  {
    meteoCode: 'RH_PROC=AVE_T=10M_Z=2M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];

/**
 * Атмосферное давление
 */
const atmospherePressureAMKWidgetData: WidgetData = [
  {
    meteoCode: 'AP_PROC=AVE_T=10M_Z=MSL',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];

/**
 * Температура почвы
 */
const soilTemperatureLevelAMKWidgetData: WidgetData = [
  {
    meteoCode: 'TG_PROC=AVE_T=10M_TYPE=YES_Z=160C',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];

/**
 * Высота снежного покрова
 */
const snowDepthAMKWidgetData: WidgetData = [
  {
    meteoCode: 'HS_PROC=AVE',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];

/**
 * Суммарная радиация
 */
const radiationLevelAMKWidgetData: WidgetData = [
  {
    meteoCode: 'RSUM_PROC=AVE_T=10M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];

/**
 * Видимость
 */
const visibilityAMKWidgetData: WidgetData = [
  {
    meteoCode: 'V_PROC=AVE_T=10M_TYPE=0_Z=10M',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];

/**
 * Напряжение батареи
 */
const batteryVoltageAMKWidgetData: WidgetData = [
  {
    meteoCode: 'LB_PROC=INS',
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    point: -1,
    place: '',
    time: null,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];

/**
 * Роза ветров
 */
const windDirectionMeteocodeId = 'WD_PROC=AVE_T=10M_TYPE=0_Z=10M';
const windRoseWidgetArrowAMKWidgetData: WidgetData = [
  {
    meteoCode: windDirectionMeteocodeId,
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    place: '',
    point: -1,
    time: null,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];
const windRoseChartWidgetData: ChartWidgetData['dataInfo'][] = [
  {
    meteoCode: windDirectionMeteocodeId,
    sourceType: 'DATASOURCE',
    stationEntityId: -1,
    place: '',
    point: -1,
    measures: [{ interval: 10, timeShift: 0, mandatory: false }],
  },
];

const complexAMKChart1: ChartWidgetData[] = [
  {
    dataInfo: {
      meteoCode: 'TA_PROC=AVE_T=10M_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
      fill: false,
    },
  },
  {
    dataInfo: {
      meteoCode: 'RH_PROC=AVE_T=10M_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgba(16, 112, 202, 0.5)',
      backgroundColor: 'rgba(11, 72, 129, 0.5)',
      fill: false,
    },
  },
  {
    dataInfo: {
      meteoCode: 'TD_PROC=AVE_T=10M_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgba(69, 224, 76, 0.5)',
      backgroundColor: 'rgba(45, 158, 50, 0.5)',
      fill: false,
    },
  },
];

const complexAMKChart2: ChartWidgetData[] = [
  {
    dataInfo: {
      meteoCode: 'WS_PROC=AVE_T=10M_TYPE=0_Z=10M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
      fill: false,
    },
  },
  {
    dataInfo: {
      meteoCode: 'AP_PROC=AVE_T=10M_Z=STN',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgba(16, 112, 202, 0.5)',
      backgroundColor: 'rgba(11, 72, 129, 0.5)',
      fill: false,
    },
  },
];
const complexAMKChart3: ChartWidgetData[] = [
  {
    dataInfo: {
      meteoCode: 'P_PROC=SUM_T=24H_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 60 * 24, timeShift: 0, mandatory: true }],
    },
    style: {
      stepped: 'after',
      fixStep: (firstPoint: any) => {
        const xKey = 'timeUTC';

        if (!firstPoint?.[xKey]) {
          return firstPoint;
        }

        const time = new Date(`${firstPoint[xKey]}Z`);
        // remove 24 hours
        time.setHours(time.getHours() - 24);

        return { ...firstPoint, [xKey]: formatInTimeZone(time, 'UTC', DATE_FORMATS.api) };
      },
      forceLabel: 'Сумма осадков за 24ч',
      borderColor: 'rgba(16, 112, 202, 0.5)',
      backgroundColor: createDiagonalPattern('rgba(16, 112, 202, 0.5)', { g45: true, g135: false, g180: false, g90: false }),
      order: 1,
    },
  },
  {
    dataInfo: {
      meteoCode: 'P_PROC=SUM_T=1H_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 60, timeShift: 0, mandatory: true }],
    },
    style: {
      type: 'bar',
      categoryPercentage: 1.0,
      barPercentage: 1.0,
      forceLabel: 'Сумма осадков за 1ч',
      borderColor: 'green',
      backgroundColor: 'rgba(0, 100, 0, 0.5)',
      fill: false,
    },
  },
];
const complexAMKChart4: ChartWidgetData[] = [
  {
    dataInfo: {
      meteoCode: 'TA_PROC=AVE_T=10M_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgb(255, 99, 132)',
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
      fill: false,
    },
  },
  {
    dataInfo: {
      meteoCode: 'P_PROC=SUM_T=24H_Z=2M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 60 * 24, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgba(16, 112, 202, 0.5)',
      backgroundColor: 'rgba(11, 72, 129, 0.5)',
      fill: false,
    },
  },
  {
    dataInfo: {
      meteoCode: 'WS_PROC=AVE_T=10M_TYPE=0_Z=10M',
      sourceType: 'DATASOURCE',
      stationEntityId: -1,
      place: '',
      point: -1,
      measures: [{ interval: 10, timeShift: 0, mandatory: false }],
    },
    style: {
      borderColor: 'rgba(69, 224, 76, 0.5)',
      backgroundColor: 'rgba(45, 158, 50, 0.5)',
      fill: false,
    },
  },
];

export {
  temperatureWidgetData,
  windWidgetData,
  rainWidgetData,
  humidityAMKWidgetData,
  atmospherePressureAMKWidgetData,
  soilTemperatureLevelAMKWidgetData,
  snowDepthAMKWidgetData,
  radiationLevelAMKWidgetData,
  visibilityAMKWidgetData,
  batteryVoltageAMKWidgetData,
  windRoseWidgetArrowAMKWidgetData,
  windRoseChartWidgetData,
  complexAMKChart1,
  complexAMKChart2,
  complexAMKChart3,
  complexAMKChart4,
};
